"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureARaaSClientSDKLogger = exports.logger = void 0;
const TempLogger = {
    extend: () => TempLogger,
    setContextValue: () => { },
    removeContextValue: () => { },
    trace: (...args) => {
        console.trace(...args);
    },
    isTrace: () => true,
    debug: (...args) => {
        console.debug(...args);
    },
    isDebug: () => true,
    info: (...args) => {
        console.info(...args);
    },
    isInfo: () => true,
    warn: (...args) => {
        console.warn(...args);
    },
    isWarn: () => true,
    error: (...args) => {
        console.error(...args);
    },
    isError: () => true,
};
exports.logger = TempLogger;
function configureARaaSClientSDKLogger(nextLogger) {
    if (nextLogger) {
        // The WebRTCPeer class is used from kurrento, and expects a Logger object to exist on the window.
        // /streem-app/web/packages/araas-client-sdk/src/webrtc_peer/index.js
        // Here we assign the logger object to the window so the file can be used
        Object.defineProperty(window, 'Logger', { value: nextLogger, configurable: true });
        exports.logger = nextLogger;
    }
}
exports.configureARaaSClientSDKLogger = configureARaaSClientSDKLogger;
//# sourceMappingURL=logger.js.map